// swalConfig.js
import Swal from "sweetalert2";

// Create a configured version of SweetAlert with higher z-index
const SwalConfig = Swal.mixin({
  customClass: {
    container: "swal-container-top-layer",
    popup: "swal-popup-top-layer",
  },
});

// Add this CSS to your global CSS or in your component
const addGlobalStyle = () => {
  const styleElement = document.createElement("style");
  styleElement.innerHTML = `
    .swal-container-top-layer {
      z-index: 9999 !important; /* Very high z-index */
    }
    
    .swal-popup-top-layer {
      z-index: 10000 !important; /* Even higher z-index */
    }
  `;
  document.head.appendChild(styleElement);
};

// Call this once when your app initializes
const initSwalConfig = () => {
  addGlobalStyle();
};

export { SwalConfig, initSwalConfig };
